import React, { useContext, useEffect, useState } from "react";
import { Button, Form, FormGroup, FormLabel } from "react-bootstrap";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Field, Formik } from "formik";
import FormSelectField from "../../Components/FormSelectField";
import { AuthContext } from "../../Auth/Context/AuthContext";
import Shop from "../../Services/shopServices";
import USDFigure from "../../Components/USDFigure";
import { Upload, message } from "antd";
import TitleHeader from "../accounts/Components/TitleHeader";
function AddShop(props) {
  const { user, floors, accounts } = useContext(AuthContext);
  const { edit } = props;
  const shopId = useParams().id;
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updatingRecord, setUpdatingRecord] = useState();
  const [shopRent, setShopRent] = useState();

  const getShopEdit = async () => {
    if (shopId) {
      setLoading(true);
      await Shop.getOne(shopId)
        .then((data) => {
          setUpdatingRecord(data.data);
          setLoading(false);
        })
        .catch((err) => {
          setError(true);
          setLoading(false);
          console.log(err);
        });
    }
  };

  const navigate = useNavigate();
  const initialValues = {
    name: updatingRecord?.name || "",
    shopNumber: updatingRecord?.shopNumber || "",
    floor: updatingRecord?.buildingFloorId || "",
    area: updatingRecord?.area || "",
    phone: updatingRecord?.phone || "",
    monthlyRent: updatingRecord?.monthlyRent || "",
    revenueAccount: updatingRecord?.revenueAccountId || "",
    maintenanceAccount: updatingRecord?.maintenanceAccountId || "",
    serviceAccount: updatingRecord?.servicesAccountId || "",
    utilitiesAccount: updatingRecord?.utilitiesAccountId || "",
    isSplittable: updatingRecord?.isSpliteable || false,
  };
  const addShop = (values) => {
    if (values.monthlyRent < 0 || values.area < 0)
      return message.warning("Monthly Rent and Area must be positive number");
    setLoading(true);
    values.branchId = user.branchId;
    values.isSpliteable = values.isSplittable;
    values.buildingFloorId = parseInt(values.floor) || 1;
    values.revenueAccountId = values.revenueAccount;
    values.maintenanceAccountId = values.maintenanceAccount;
    values.maintenanceAccountName = accounts.find(
      (op) => op.id === parseInt(values.maintenanceAccount)?.name
    );
    values.servicesAccountId = values.serviceAccount;
    values.servicesAccountName = accounts.find(
      (op) => op.id === parseInt(values.serviceAccount)?.name
    );
    values.utilitiesAccountId = values.utilitiesAccount;
    values.utilitiesAccountName = accounts.find(
      (op) => op.id === parseInt(values.utilitiesAccount)?.name
    );
    values.revenueAccountName = accounts.find(
      (op) => op.id === parseInt(values.revenueAccount)?.name
    );
    values.buildingFloorFloorNumber = floors.find(
      (op) => op.id === parseInt(values.floor)
    )?.floorNumber;
    values.monthlyRent = values.monthlyRent || shopRent;
    if (shopId) {
      values.id = shopId;
      Shop.update(values, shopId)
        .then((data) => {
          message.success("Updated Successfully");
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          message.error("Faild to Save Shop");
          console.log(err);
        });
    } else
      Shop.add(values)
        .then((data) => {
          setLoading(false);
          if (data.data.status === "Fail")
            return message.error("Failed to save");
          else message.success("Shop Saved Successfully");
          navigate(`/shop-details/${data.data.id}`);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          message.error(err.response.data?.message);
        });
  };

  const importFile = async (file) => {
    if (!file) return message.warning("Please Select a file first");
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    Shop.importShops(formData)
      .then((response) => {
        message.success("Shops imported Successfully");
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        message.error("Failed to Import");
        console.log("Network Error", error);
      });
  };
  useEffect(() => {
    getShopEdit();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <TitleHeader title="Add New Shop" />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Upload onChange={(e) => importFile(e.file.originFileObj)}>
              <a className="btn btn-light">
                <i
                  class="ion-ios7-cloud-download"
                  data-bs-toggle="tooltip"
                  title="Import File"
                ></i>{" "}
                Import
              </a>
            </Upload>
          </div>
          <div class="card">
            <div class="card-body">
              {!error && (
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  onSubmit={addShop}
                >
                  {({ values, setFieldValue, handleSubmit }) => (
                    <Form autoComplete="off" onSubmit={handleSubmit}>
                      <FormGroup class="mb-3">
                        <div class="row">
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Shop Name</FormLabel>
                              <Field type="text" name="name" required />
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Shop Number</FormLabel>
                              <Field type="text" name="shopNumber" required />
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Floor</FormLabel>
                              <FormSelectField
                                type="select"
                                name="floor"
                                setFieldValue={setFieldValue}
                              >
                                <option value="">Select</option>
                                {floors &&
                                  floors.map((floor) => (
                                    <option value={floor.id}>
                                      Floor # {floor.floorNumber}
                                    </option>
                                  ))}
                              </FormSelectField>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>
                                Shop Area (m<sup>2</sup>)
                              </FormLabel>
                              <Field type="number" name="area" required />
                            </div>
                          </div>
                          {setShopRent(
                            floors.find(
                              (op) => op.id === parseInt(values.floor)
                            )?.feePerSquareMeter * values.area || 0
                          )}
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <div className="d-flex">
                                <FormLabel>Monthly Rent</FormLabel>
                                (<USDFigure amount={shopRent} />)
                              </div>
                              <Field name="monthlyRent" type="number" />
                            </div>
                          </div>

                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Phone</FormLabel>
                              <Field
                                type="text"
                                name="phone"
                                // pattern="^((\+93))(7)([0-9]{8})$"
                                placeholder="07********"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Revenue Account</FormLabel>
                              <FormSelectField
                                type="select"
                                name="revenueAccount"
                                setFieldValue={setFieldValue}
                              >
                                <option value="">Select</option>
                                {accounts &&
                                  accounts
                                    .filter(
                                      (op) =>
                                        op.generalAccountCategory === "Income"
                                    )
                                    .map((account) => (
                                      <option value={account.id}>
                                        {account.name}
                                      </option>
                                    ))}
                              </FormSelectField>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Maintenance Account</FormLabel>
                              <FormSelectField
                                type="select"
                                name="maintenanceAccount"
                                setFieldValue={setFieldValue}
                              >
                                <option value="">Select</option>
                                {accounts &&
                                  accounts
                                    .filter(
                                      (op) =>
                                        op.generalAccountCategory === "Income"
                                    )
                                    .map((account) => (
                                      <option value={account.id}>
                                        {account.name}
                                      </option>
                                    ))}
                              </FormSelectField>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Service Account</FormLabel>
                              <FormSelectField
                                type="select"
                                name="serviceAccount"
                                setFieldValue={setFieldValue}
                              >
                                <option value="">Select</option>
                                {accounts &&
                                  accounts
                                    .filter(
                                      (op) =>
                                        op.generalAccountCategory === "Income"
                                    )
                                    .map((account) => (
                                      <option value={account.id}>
                                        {account.name}
                                      </option>
                                    ))}
                              </FormSelectField>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Utility Account</FormLabel>
                              <FormSelectField
                                type="select"
                                name="utilitiesAccount"
                                setFieldValue={setFieldValue}
                              >
                                <option value="">Select</option>
                                {accounts &&
                                  accounts
                                    .filter(
                                      (op) =>
                                        op.generalAccountCategory === "Income"
                                    )
                                    .map((account) => (
                                      <option value={account.id}>
                                        {account.name}
                                      </option>
                                    ))}
                              </FormSelectField>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                              <FormLabel>Is Shop Splittable?</FormLabel>
                              <FormSelectField
                                type="select"
                                name="isSplittable"
                                setFieldValue={setFieldValue}
                              >
                                <option value="">Select</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </FormSelectField>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <Button
                              className="btn btn-submit me-2"
                              type="submit"
                            >
                              Save
                            </Button>
                            <NavLink to="/shop-list" className="btn btn-cancel">
                              Cancel
                            </NavLink>
                          </div>
                        </div>
                      </FormGroup>
                    </Form>
                  )}
                </Formik>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddShop;
